import {
	Button,
	FilterIcon,
	RadioIcon,
	MenuButton,
	ThemeColorVariable,
	ThemeIconSizeVariable,
} from "@caspeco/casper-ui-library";

export const FilterIconButton = ({
	activeFilter,
	onClick,
}: {
	activeFilter: boolean;
	onClick?: () => void;
}) => {
	return (
		<Button variant={"ghost"} p={0} onClick={onClick} data-testid="filter-icon-button">
			<FilterIconContainer activeFilter={activeFilter}></FilterIconContainer>
		</Button>
	);
};

export const FilterIconMenuButton = ({
	activeFilter,
	onClick,
}: {
	activeFilter: boolean;
	onClick?: () => void;
}) => {
	return (
		<MenuButton variant={"ghost"} p={0} onClick={onClick} data-testid="filter-menu-button">
			<FilterIconContainer activeFilter={activeFilter} />
		</MenuButton>
	);
};

const FilterIconContainer = ({ activeFilter }: { activeFilter: boolean }) => {
	return (
		<>
			<FilterIcon />
			{activeFilter && (
				<RadioIcon
					position="absolute"
					top="0"
					right="0"
					color={ThemeColorVariable.Error}
					size={ThemeIconSizeVariable.Small}
				/>
			)}
		</>
	);
};
